module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left_col scroll-view"
  }, [_c('div', {
    staticClass: "hidden-sm-and-down left_col_wrapper white"
  }, [_c('dl', {
    staticClass: "ml-3 mt-4 setting-menu"
  }, [_c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-4",
    class: {
      'current-page': _vm.$route.path === '/display'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/settings/display"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.display-setting")))])], 1), _vm._v(" "), _c('dt', [_vm._v(_vm._s(_vm.$t("settings.available-sensor")))]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/plugins'
    }
  }, [(_vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#flowsensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.flow")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.flow")))])], 1), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/plugins'
    }
  }, [(_vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#tdssensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.tds")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.tds")))])], 1), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/plugins'
    }
  }, [(_vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#pressuresensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.pressure")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.pressure")))])], 1), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/plugins'
    }
  }, [(_vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#leakagesensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.leakage")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.leakage")))])], 1), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.requiredRoles([])),
      expression: "requiredRoles([])"
    }],
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/plugins'
    }
  }, [(_vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#temperaturesensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.temperature")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.temperature")))])], 1), _vm._v(" "), _c('dt', [_vm._v(_vm._s(_vm.$t("settings.life-and-notification")))]), _vm._v(" "), _c('dd', {
    staticClass: "mb-4 grey--text",
    class: {
      'current-page': _vm.$route.path === ''
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.notification-presets")))]), _vm._v(" "), _c('dd', {
    staticClass: "mb-3",
    class: {
      'current_page': _vm.$route.path === '/settings/notifications_mail'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/settings/notifications_mail"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.notification-mail")))])], 1), _vm._v(" "), _c('dt', [_vm._v(_vm._s(_vm.$t("settings.organization-user")))]), _vm._v(" "), (_vm.userRole === _vm.ROLE_Root) ? _c('dd', {
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/pc_list'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/settings/pc_list"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.pc-management")))])], 1) : _vm._e(), _vm._v(" "), (_vm.userRole !== _vm.ROLE_Root) ? _c('dd', {
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/organizations_detail'
    }
  }, [(_vm.userRole !== _vm.ROLE_Staff && _vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/organizations_detail"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.management-organization")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.management-organization")))])], 1) : _vm._e(), _vm._v(" "), (_vm.userRole !== _vm.ROLE_Root) ? _c('dd', {
    staticClass: "mb-3",
    class: {
      'current-page': _vm.$route.path === '/user_list'
    }
  }, [(_vm.userRole !== _vm.ROLE_Staff && _vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/user_list"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.user-management")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.user-management")))])], 1) : _vm._e(), _vm._v(" "), (_vm.userRole !== _vm.ROLE_Root) ? _c('dd', {
    staticClass: "mb-4",
    class: {
      'current-page': _vm.$route.path === '/user_invite'
    }
  }, [(_vm.userRole !== _vm.ROLE_Staff && _vm.userRole !== _vm.ROLE_Viewer) ? _c('router-link', {
    attrs: {
      "to": "/settings/user_invite"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.user-invitation")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.user-invitation")))])], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-38469528","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsSidebar.vue
// module id = 1918
// module chunks = 0